import { toggle } from "@otto-ec/global-resources/toggle"
import { isOnexVariant } from "@otto-ec/global-resources/onex"
import { init as initRefreshByOrt } from "./refreshByOrt"
import { init as initRefreshByOwt } from "./refreshByOwt"

export function initRefresh() {
    if (toggle.get("fti_enable_session_refresh_by_ort") || isOnexVariant("E3698", "E3698B")) {
        initRefreshByOrt()
    } else {
        initRefreshByOwt()
    }
}

initRefresh()
